<div
  class="modal-dialog view-receipt-modal modal-dialog-scrollable m-0 scrollable-dialog"
>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">View Receipt ({{ data.withdrawal.id }})</h5>
      <span class="modal-x-button" (click)="onCloseDialog()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </span>
    </div>
    <div class="modal-body">
      <ngb-carousel *ngIf="data.withdrawal.receipt.length > 0">
        <ng-template
          ngbSlide
          *ngFor="let receipt of data.withdrawal.receipt; let i = index"
        >
          <div class="picsum-img-wrapper">
            <div class="receipt-media-wrapper">
              <img
                *ngIf="checkMedia(receipt.receipt_image) == 'image'"
                class="receipt-media"
                [src]="receipt.receipt_image"
                alt="Withdrawal receipt"
              />
              <object
                *ngIf="checkMedia(receipt.receipt_image) == 'pdf'"
                class="receipt-media receipt-pdf"
                [data]="receipt.receipt_image | safe : 'resourceUrl'"
                type="application/pdf"
              ></object>
              <p class="receipt-desc">Withdraw Receipt (Bank Transaction ID: {{ receipt.bank_transaction_id }})<br>{{ receipt.bank_transaction_created_at | timezoneDate: 'YYYY-MM-DD HH:mm:ss' }}</p>
            </div>
          </div>
        </ng-template>
      </ngb-carousel>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="onCloseDialog($event)"
      >
        <i class="fas fa-ban"></i>Close
      </button>
    </div>
  </div>
</div>
